"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pruneOrdersTradeYes = void 0;
const web3_js_1 = require("@solana/web3.js"); // eslint-disable-line @typescript-eslint/no-unused-vars
const programId_1 = require("../programId");
function pruneOrdersTradeYes(accounts) {
    const keys = [
        { pubkey: accounts.user, isSigner: false, isWritable: false },
        { pubkey: accounts.tradeYes, isSigner: false, isWritable: false },
        { pubkey: accounts.market, isSigner: false, isWritable: false },
        { pubkey: accounts.bracket, isSigner: false, isWritable: false },
        { pubkey: accounts.serumMarket, isSigner: false, isWritable: true },
        {
            pubkey: accounts.serumAccounts.requestQueue,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.serumAccounts.eventQueue,
            isSigner: false,
            isWritable: true,
        },
        { pubkey: accounts.serumAccounts.bids, isSigner: false, isWritable: true },
        { pubkey: accounts.serumAccounts.asks, isSigner: false, isWritable: true },
        {
            pubkey: accounts.serumAccounts.coinVault,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.serumAccounts.pcVault,
            isSigner: false,
            isWritable: true,
        },
        {
            pubkey: accounts.serumAccounts.vaultSigner,
            isSigner: false,
            isWritable: false,
        },
        { pubkey: accounts.openOrders, isSigner: false, isWritable: true },
        { pubkey: accounts.usdcVault, isSigner: false, isWritable: true },
        { pubkey: accounts.fUsdcMint, isSigner: false, isWritable: true },
        { pubkey: accounts.unlockedYes, isSigner: false, isWritable: true },
        { pubkey: accounts.lockedFUsdc, isSigner: false, isWritable: true },
        { pubkey: accounts.internalUsdc, isSigner: false, isWritable: true },
        { pubkey: accounts.marketPnl, isSigner: false, isWritable: false },
        { pubkey: accounts.tokenProgram, isSigner: false, isWritable: false },
        { pubkey: accounts.dexProgram, isSigner: false, isWritable: false },
        { pubkey: accounts.rent, isSigner: false, isWritable: false },
    ];
    const identifier = Buffer.from([171, 138, 165, 71, 83, 173, 203, 130]);
    const data = identifier;
    const ix = new web3_js_1.TransactionInstruction({ keys, programId: programId_1.PROGRAM_ID, data });
    return ix;
}
exports.pruneOrdersTradeYes = pruneOrdersTradeYes;
//# sourceMappingURL=pruneOrdersTradeYes.js.map